import React, { useState, useEffect } from "react";
import { X, HelpCircle, ChevronDown, ExternalLink, BookOpen, Users, ClipboardCheck, Settings } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

const helpMenuItems = [
  {
    id: "uygulama-rehberi",
    title: "UYGULAMA REHBERİ",
    icon: BookOpen,
    items: [
      {
        title: "Tarayıcı Rehberi",
        url: "https://dokumantasyon.yeniegitimsistemi.net/uygulama-rehberi/tarayici-rehberi.html",
      },
      {
        title: "Toplantı Rehberi",
        url: "https://dokumantasyon.yeniegitimsistemi.net/uygulama-rehberi/toplanti-rehberi.html",
      },
      {
        title: "Uzaktan Erişim Rehberi",
        url: "https://dokumantasyon.yeniegitimsistemi.net/uygulama-rehberi/uzaktan-erisim-rehberi.html",
      },
    ],
  },
  {
    id: "veli-rehberi",
    title: "VELİ REHBERİ",
    icon: Users,
    items: [
      {
        title: "iPhone Ebeveyn Denetimleri",
        url: "https://dokumantasyon.yeniegitimsistemi.net/veli-rehberi/iphone.html",
      },
      {
        title: "Samsung Ebeveyn Denetimleri",
        url: "https://dokumantasyon.yeniegitimsistemi.net/veli-rehberi/samsung.html",
      },
      {
        title: "Realme Ebeveyn Denetimleri",
        url: "https://dokumantasyon.yeniegitimsistemi.net/veli-rehberi/realme-ebeveyn-denetimleri.html",
      },
    ],
  },
  {
    id: "ogretmen-rehberi",
    title: "ÖĞRETMEN REHBERİ",
    icon: ClipboardCheck,
    items: [
      {
        title: "E-Eğitim",
        subItems: [
          {
            title: "Derslere Nasıl İçerik Eklenir?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/e-egitim/derslere-nasil-icerik-eklenir.html",
          },
          {
            title: "Testlere Toplu Soru ve Cevap Anahtarı Nasıl Yüklenir?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/e-egitim/testlere-toplu-soru-ve-cevap-anahtari-nasil-yuklenir.html",
          },
          {
            title: "Derslerdeki İçerikler Nasıl Düzenlenir?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/e-egitim/derslerdeki-icerikler-nasil-duzenlenir.html",
          },
          {
            title: "Video İçeriklerine Kazanım Nasıl Eklenir?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/e-egitim/video-iceriklerine-kazanim-nasil-eklenir.html",
          },
          {
            title: "Akademik Takvim Nasıl Kullanılır?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/e-egitim/akademik-takvim-nasil-kullanilir.html",
          },
        ],
      },
      {
        title: "Toplantılar",
        subItems: [
          {
            title: "Toplantı Nasıl Oluşturulur?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/toplantilar/toplanti-nasil-olusturulur.html",
          },
          {
            title: "Toplantılara Nasıl Katılınır?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/toplantilar/toplantilara-nasil-katilinir.html",
          },
        ],
      },
      {
        title: "Anketler",
        subItems: [
          {
            title: "Anket Nasıl Oluşturulur?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogretmen-rehberi/anketler/anket-nasil-olusturulur.html",
          },
        ],
      },
    ],
  },
  {
    id: "ogrenci-rehberi",
    title: "ÖĞRENCİ REHBERİ",
    icon: BookOpen,
    items: [
      {
        title: "Toplantılar",
        subItems: [
          {
            title: "Toplantılara Nasıl Katılınır?",
            url: "https://dokumantasyon.yeniegitimsistemi.net/ogrenci-rehberi/toplantilar/toplantilara-nasil-katilinir.html",
          },
        ],
      },
    ],
  },
  {
    id: "sorun-cozumu",
    title: "SORUN ÇÖZÜMÜ",
    icon: Settings,
    items: [
      {
        title: "Toplantılar",
        subItems: [
          {
            title: "Toplantılara Neden Katılamıyorum? – Pencereleri Engelle (iOS)",
            url: "https://dokumantasyon.yeniegitimsistemi.net/sorun-cozumu/toplantilar/toplantilara-neden-katilamiyorum-ios.html",
          },
          {
            title: "Toplantılara Neden Katılamıyorum? – Pop-up ve Yönlendirmeler (Android)",
            url: "https://dokumantasyon.yeniegitimsistemi.net/sorun-cozumu/toplantilar/toplantilara-neden-katilamiyorum-android.html",
          },
          {
            title: "Toplantılara Neden Katılamıyorum? – Uygulama Açılmıyor",
            url: "https://dokumantasyon.yeniegitimsistemi.net/sorun-cozumu/toplantilar/toplantilara-neden-katilamiyorum-uygulama-acilmiyor.html",
          },
        ],
      },
    ],
  },
];

const HelpPanel = ({ isOpen, onClose, isHomePage = false }: { isOpen: boolean; onClose?: () => void; isHomePage?: boolean }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [expandedCategories, setExpandedCategories] = useState<string[]>([]);
  const { currentTheme } = useTheme();
  const panelPositionClass = isMobile ? "inset-0 top-[60px]" : "top-[60px] right-0 bottom-0 w-80";

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const toggleCategory = (categoryId: string) => {
    setExpandedCategories((prev) => (prev.includes(categoryId) ? prev.filter((c) => c !== categoryId) : [...prev, categoryId]));
  };

  if (!isOpen) return null;

  return (
    <>
      <style>
        {`
          .help-container::-webkit-scrollbar {
            display: none;
          }
          .help-container {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>

      {isMobile && <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={onClose} />}

      {!isHomePage && <div className={`fixed z-49 bg-white ${panelPositionClass}`} />}

      <div className={`fixed z-50 ${panelPositionClass}`}>
        <div
          className={`flex flex-col h-full shadow-2xl w-full ${isHomePage ? "backdrop-blur-lg" : "bg-white"} ${
            isMobile ? "rounded-none p-0" : isHomePage ? "border border-white/25 p-1" : "border border-gray-200 p-1"
          }`}
          style={
            isHomePage
              ? {
                  background: `linear-gradient(135deg, ${currentTheme.colors.background.base}26, ${currentTheme.colors.background.via}33, ${currentTheme.colors.background.to}26)`,
                }
              : undefined
          }>
          <div className="flex-shrink-0 px-6" style={{ paddingTop: "11px", paddingBottom: "11px" }}>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <div className="w-8 h-8 bg-indigo-500 rounded-full flex items-center justify-center">
                    <HelpCircle size={16} className="text-white" />
                  </div>
                </div>

                <div className="flex-1">
                  <h2 className={`text-sm font-semibold ${isHomePage ? "text-white" : "text-gray-900"}`}>Yardım ve Dokümantasyon</h2>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                {onClose && (
                  <button
                    onClick={onClose}
                    className={`p-1.5 rounded transition-colors ${
                      isHomePage
                        ? "text-gray-200 hover:text-white hover:bg-white/15"
                        : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                    }`}
                    aria-label="Kapat">
                    <X size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="help-container flex-1 overflow-y-auto px-6 py-4">
            {helpMenuItems.map((section, sectionIndex) => (
              <div key={section.id} className={sectionIndex > 0 ? "mt-6" : ""}>
                <div className={`px-3 py-2 flex items-center gap-2 rounded-lg mb-2 ${isHomePage ? "bg-white/10" : "bg-gray-50"}`}>
                  <section.icon size={14} className={isHomePage ? "text-white" : "text-gray-700"} />
                  <span className={`text-xs font-bold tracking-wide ${isHomePage ? "text-white" : "text-gray-900"}`}>{section.title}</span>
                </div>

                <div className="space-y-1">
                  {section.items.map((item) => {
                    const categoryId = `${section.id}-${item.title}`;
                    return (
                      <div key={item.title}>
                        {"url" in item ? (
                          <a
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all group ${
                              isHomePage ? "hover:bg-white/15" : "hover:bg-gray-100"
                            }`}>
                            <span
                              className={`text-sm ${
                                isHomePage ? "text-gray-200 group-hover:text-white" : "text-gray-700 group-hover:text-gray-900"
                              }`}>
                              {item.title}
                            </span>
                            <ExternalLink
                              size={12}
                              className={`${
                                isHomePage ? "text-gray-400 group-hover:text-gray-300" : "text-gray-500 group-hover:text-gray-700"
                              }`}
                            />
                          </a>
                        ) : "subItems" in item ? (
                          <div>
                            <button
                              onClick={() => toggleCategory(categoryId)}
                              className={`w-full flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer transition-all ${
                                expandedCategories.includes(categoryId)
                                  ? isHomePage
                                    ? "bg-white/20"
                                    : "bg-blue-50"
                                  : isHomePage
                                  ? "hover:bg-white/10"
                                  : "hover:bg-gray-50"
                              }`}>
                              <span
                                className={`text-sm font-medium ${
                                  isHomePage ? "text-gray-200" : expandedCategories.includes(categoryId) ? "text-blue-700" : "text-gray-700"
                                }`}>
                                {item.title}
                              </span>
                              <ChevronDown
                                size={14}
                                className={`transition-transform ${expandedCategories.includes(categoryId) ? "rotate-180" : ""} ${
                                  isHomePage ? "text-gray-400" : "text-gray-500"
                                }`}
                              />
                            </button>

                            {expandedCategories.includes(categoryId) && (
                              <div className={`mt-1 ml-3 space-y-1 ${isHomePage ? "bg-black/10" : "bg-gray-50/50"} rounded-lg p-2`}>
                                {item.subItems.map((subItem: { title: string; url: string }) => (
                                  <a
                                    key={subItem.title}
                                    href={subItem.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`flex items-center justify-between px-2 py-1.5 rounded cursor-pointer transition-all group ${
                                      isHomePage ? "hover:bg-white/15" : "hover:bg-white"
                                    }`}>
                                    <span
                                      className={`text-xs ${
                                        isHomePage ? "text-gray-300 group-hover:text-white" : "text-gray-600 group-hover:text-gray-900"
                                      }`}>
                                      {subItem.title}
                                    </span>
                                    <ExternalLink
                                      size={10}
                                      className={`flex-shrink-0 ml-2 ${
                                        isHomePage ? "text-gray-500 group-hover:text-gray-400" : "text-gray-400 group-hover:text-gray-600"
                                      }`}
                                    />
                                  </a>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : null}
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          <div className="flex-shrink-0 px-6 py-4 space-y-3">
            <a
              href="https://dokumantasyon.yeniegitimsistemi.net"
              target="_blank"
              rel="noopener noreferrer"
              className={`w-full px-4 py-2 border rounded-lg transition-colors font-medium flex items-center justify-center gap-2 ${
                isHomePage
                  ? "text-white bg-white/15 border-white/25 hover:bg-white/20 backdrop-blur-sm"
                  : "text-blue-700 bg-blue-50 border-blue-200 hover:bg-blue-100"
              }`}>
              <span>Tüm Dokümantasyonu Görüntüle</span>
              <ExternalLink size={14} />
            </a>
            <button
              onClick={onClose}
              className={`w-full px-4 py-2 border rounded-lg transition-colors font-medium ${
                isHomePage
                  ? "text-white bg-white/15 border-white/25 hover:bg-white/20 backdrop-blur-sm"
                  : "text-gray-700 bg-white border-gray-300 hover:bg-gray-50"
              }`}>
              Kapat
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HelpPanel;
